/**
 * Maps the termination object payload for submit change cover API
 * @param {object} policyChangesStep policy changes step information, should include:
 *                                    - terminated product codes list
 *                                    - selected termination reasons object
 * @param {object} partnerStep partner step information
 * @param {object} childrenStep children step information
 * @param {object} extraData bundled data used for checks. This includes:
 *                            - showNewPartnerSection Boolean for whether there is a new partner on the policy
 *                            - oldCompositionHavePartner, boolean for whether old composition had partner
 * @returns
 */
// eslint-disable-next-line import/prefer-default-export
export const mapTerminationObj = (policyChangesStep, partnerStep, childrenStep, extraData) => {
  const terminations = {
    products: [],
    partner: null,
    children: null,
  };

  // If product termination then add to terminations
  if (extraData.showPolicy) {
    terminations.products = policyChangesStep.terminatedProductCodes.map((productCode) => {
      const policyObj = policyChangesStep.selectedTerminationReasons.policy;
      const policyTerminationObj = {
        productCode,
        terminationReason: policyObj.reason,
      };
      if (policyObj.fund) {
        policyTerminationObj.fundName = policyObj.fund;
      }
      return policyTerminationObj;
    });
  }

  // If there is a new partner or there was a previous partner and there is no longer a partner, add partner to terminations
  if (extraData.oldCompositionHavePartner && (extraData.showNewPartnerSection || !extraData.newCompositionHavePartner)) {
    const partnerTermination = extraData.newCompositionHavePartner ? partnerStep : policyChangesStep.selectedTerminationReasons.partner;
    const terminationReason = extraData.newCompositionHavePartner ? partnerTermination.terminationReason : partnerTermination.reason;
    const fundNameValue = extraData.newCompositionHavePartner ? partnerTermination.fundName : partnerTermination.fund;

    const partnerTerminationObj = {
      personCode: partnerStep.personCode,
      terminationReason,
    };

    if (extraData.transferToFundValues.includes(terminationReason)) {
      partnerTerminationObj.fundName = fundNameValue;
    }

    terminations.partner = partnerTerminationObj;
  }

  if (extraData.oldCompositionHaveChildren) {
    let childrenTerminationList = null;
    if (!extraData.newCompositionHaveChildren) {
      childrenTerminationList = policyChangesStep.selectedTerminationReasons.children.map((child) => {
        const childTerminationObj = {
          personCode: child.personCode,
          terminationReason: child.reason,
        };
        if (extraData.transferToFundValues.includes(child.reason)) {
          childTerminationObj.fundName = child.fund;
        }
        return childTerminationObj;
      });
    }
    if (extraData.newCompositionHaveChildren) {
      if (childrenStep.terminations && childrenStep.terminations.length > 0) {
        childrenTerminationList = childrenStep.terminations.map((termination) => {
          return {
            terminationReason: termination.terminationReason,
            personCode: termination.personCode,
          };
        });
      }
    }

    terminations.children = childrenTerminationList;
  }

  return terminations;
};
